import React, { useEffect, useState } from "react";
import "./index.css";
import { useNavigate, useLocation } from "react-router-dom";
import { verify2FA } from "../../../../functions/auth";
import { toast } from "react-toastify";
import Loading from "../../../../modal/Loading";
import Cookies from "universal-cookie";
import { useDispatch } from "react-redux";
import { userauthReducer } from "../../../../components/toolkit/authReducer";
const Verification = () => {
  const [verificationCode, setVerificationCode] = useState("");
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { data } = location.state || {}
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const cookies = new Cookies();
  const tokenC = data?.token?.accessToken;
  const userNameC = cookies.get("userName");
  useEffect(() => {
    if (!data && tokenC && userNameC) {
      navigate("/dashboard");
      dispatch(
        userauthReducer({
          token: tokenC,
          username: userNameC,
        })
      );
    }
  }, [tokenC, userNameC, data]);




  const handleVerification = async (e) => {
    e.preventDefault();
    if (!verificationCode || verificationCode.length !== 6) {
      toast.error("Please enter a valid 6-digit code");
      return;
    }

    setLoading(true);
    try {
      const response = await verify2FA(tokenC, verificationCode);

      cookies.set("token", data?.token?.accessToken, {
        expires: new Date(new Date().getTime() + 7 * 60 * 60 * 1000),
        maxAge: 7 * 60 * 60,
      });
      cookies.set("refreshToken", data.token.refreshToken, {
        expires: new Date(new Date().getTime() + 7 * 60 * 60 * 1000),
        maxAge: 7 * 60 * 60, 
      });
      cookies.set("userName", data.user.email);
      cookies.set("userId", data.user.id);
      cookies.set("name", data.user.name);
      localStorage.setItem("userData", JSON.stringify(data.user));

      toast.success("2FA verification successful!");
      navigate("/dashboard");
    } catch (error) {
      toast.error(error.response?.data?.message || "Invalid verification code");
      setLoading(false);
    }
  };


  const handleBackupCode = () => {
    navigate("/verify-backup", { state: { data } });
  };

  return (
    <div className="container1">
      {loading && <Loading />}
      <div className="loginheader">
        <div className="d-flex gap-2 justify-content-center">
          <img
            alt=""
            src="/images/Union.png"
            style={{ width: "30px", height: "24px" }}
          />
          <h2 className="header">Pronto</h2>
        </div>
      </div>

      <div className="pcont">
        <div className="p-4">
          <div className="row">
            <div className="col-md-4 offset-md-4">
              <div className="text-center mb-4">
                <img
                  alt=""
                  src="/images/group.png"
                  style={{
                    width: "6rem",
                    height: "5rem",
                    display: "flex",
                    margin: "auto",
                  }}
                />
                <div className="textJ">Two-Factor Authentication</div>
                <div
                  className="textJ mt-2"
                  style={{ fontSize: "14px", fontWeight: "400", color: "#666" }}
                >
                  Enter the 6-digit code from your authenticator app
                </div>
              </div>

              <div className="card p-4" style={{ backgroundColor: "white", borderRadius: "8px" }}>
                <form onSubmit={handleVerification}>
                  <div className="mb-3">
                    <label className="form-label">Verification Code</label>
                    <input
                      type="text"
                      className="form-control text-center"
                      value={verificationCode}
                      onChange={(e) => setVerificationCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                      placeholder="000000"
                      maxLength="6"
                      style={{ fontSize: "1.5rem", letterSpacing: "0.5rem" }}
                      autoComplete="off"
                      autoFocus
                    />
                  </div>

                  <div className="d-grid gap-2">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={verificationCode.length !== 6 || loading}
                    >
                      {loading ? "Verifying..." : "Verify & Continue"}
                    </button>
                  </div>
                </form>

                <div className="text-center mt-3">
                  {/* <div className="mb-2">
                    <small className="text-muted">
                      Code expires in: {timeLeft}s
                    </small>
                  </div> */}

                  <div className="d-flex gap-2 justify-content-center">
                    <button
                      className="btn btn-link btn-sm"
                      onClick={handleBackupCode}
                    >
                      Use Backup Code
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Verification;

